type Listener = () => void;

const listeners = new Set<Listener>();

export const savedFiltersEvents = {
  subscribe: (listener: Listener): (() => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },

  notify: (): void => {
    listeners.forEach(listener => listener());
  },
};
